import React, { FunctionComponent, ReactNode } from 'react';
import { Trans } from 'react-i18next';

import Avatar from '@justgiving/avatar';

import parseCurrency from '../../utils/parseCurrency';
import TimestampWrapper from '../TimestampWrapper/TimestampWrapper';
import UserListItem from '../UserListItem/UserListItem';
import styles from './ESSupporterDetails.scss';

export type SupporterDetailsProps = {
  image?: string;
  date?: string;
  donationAmount?: number | null;
  currencyCode?: string;
  giftAidAmount?: number;
  userName: string | ReactNode | null;
  message: string | ReactNode;
};

const ESSupporterDetails: FunctionComponent<SupporterDetailsProps> = ({
  image,
  date,
  donationAmount,
  currencyCode,
  giftAidAmount,
  userName,
  message,
}) => {
  return (
    <UserListItem
      // ! currently implementing a font override because of the default fontSize and lineHeight
      // TODO implement CpAvatar when it's updated picture={<CpAvatar src={image!} size="auto" alt="" />}
      picture={<Avatar avatarSize="auto" picture={image} />}
      alignTop
    >
      <h2
        className={`cp-body-large ${styles.supporterTitle}`}
        data-qa="supporter-title"
      >
        {userName || <Trans i18nKey="common.anonymous" />}
        {date && (
          <span className={`${styles.donationTimestamp} cp-body-small`}>
            <TimestampWrapper date={date} />
          </span>
        )}
      </h2>
      <p className={`cp-body-medium ${styles.donationMessage}`}>{message}</p>
      <DonationAmounts
        donationAmount={donationAmount !== null ? donationAmount : undefined}
        currencyCode={currencyCode}
        giftAidAmount={giftAidAmount}
      />
    </UserListItem>
  );
};

type DonationAmountsProps = {
  donationAmount?: number;
  currencyCode?: string;
  giftAidAmount?: number;
};

const DonationAmounts: FunctionComponent<DonationAmountsProps> = ({
  donationAmount,
  currencyCode,
  giftAidAmount,
}) => {
  if (!donationAmount || donationAmount <= 0 || !currencyCode) {
    return null;
  }

  return (
    <>
      {donationAmount > 0 && (
        <p
          className={`jg-text-color-branded ${styles.donationAmount}`}
          data-qa="donation-amount"
        >
          {parseCurrency(currencyCode, donationAmount)}
          {typeof giftAidAmount === 'number' && giftAidAmount > 0 && (
            <span className={`jg-text-color-branded ${styles.donationAmount}`}>
              {` + `}
              {parseCurrency(currencyCode, giftAidAmount)}{' '}
              <Trans i18nKey="common.giftaid" />
            </span>
          )}
        </p>
      )}
    </>
  );
};

export default ESSupporterDetails;
